import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useLocation, useHistory } from "react-router-dom";
import { matchPath } from "react-router";
import { useUserSubscription } from "modules/selectors/users";
import { SubscribeModal } from "app/components/SubscribeModal";
import { Routes } from "constants/routes";
import { useIntroOfferCoupon } from "hooks/Checkout/useIntroOfferCoupon";
// Routes where we shouldn't show the subscription modal
const EXCLUDED_ROUTES = [
  Routes.checkout,
  Routes.upgrade,
  Routes.account__subscription,
  Routes.login,
  Routes.register,
  Routes.intro_offer,
  Routes.not_found,
];

/**
 * Component that checks if user has an active subscription
 * Shows the subscribe modal if the user doesn't have an active subscription on initial app load
 */
export const SubscriptionCheck: React.FC = () => {
  const history = useHistory();
  const [showModal, setShowModal] = useState<boolean>(false);
  const { isSubscriptionActive } = useUserSubscription();
  const { isEligibleForIntroOffer } = useIntroOfferCoupon();
  const userSubscriptionLoaded = useSelector(
    ({ user }: any) => user.subscription.loaded
  );
  const location = useLocation();
  const { pathname } = location;

  // Check if current route is excluded from showing the modal
  const isExcludedRoute = EXCLUDED_ROUTES.some(route =>
    matchPath(pathname, { path: route, exact: true })
  );

  useEffect(() => {
    // Only show modal after subscription data has loaded and user doesn't have active subscription
    // and we're not on an excluded route
    if (userSubscriptionLoaded && !isSubscriptionActive && !isExcludedRoute) {
      setShowModal(true);
    }
  }, [isSubscriptionActive, userSubscriptionLoaded]);

  const closeModal = () => {
    setShowModal(false);
    if (isEligibleForIntroOffer) {
      history.push(Routes.intro_offer);
    }
  };

  if (!showModal) {
    return null;
  }

  return <SubscribeModal isOpen={showModal} closeModal={closeModal} />;
};
